import React, { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineClose } from "react-icons/ai";
import { FiDownload } from "react-icons/fi";


const CreditPackageSuccess = ({
    credits,
    paymentRes,
    currency,
    amount,
    setOpenCreditPackageModal
} : {
    credits: any;
    paymentRes: any;
    currency: string;
    amount: any;
    setOpenCreditPackageModal : Dispatch<SetStateAction<boolean>>
}) => {
  const { receiptUrl } = paymentRes;
  const {t} = useTranslation();

  return (
    <div className="bg-white font-semibold rounded w-full max-w-lg sm:min-w-[512px] mx-auto z-[5100]">
        <div className="text-white bg-secondary py-5 flex items-center justify-between flex-wrap gap-4 md:rounded-t text-2xl font-semibold px-5">
            <h4
                id="paymentSuccess"
                className="text-2xl lg:text-3xl font-semibold"
            >
                {t("BookingModal.paymentSuccessful")}
            </h4>
            <button
                className="btn"
                onClick={() => {
                    setOpenCreditPackageModal(false);
                }}
            >
                <AiOutlineClose className="pointer-events-none touch-none w-6 h-6 lg:w-8 lg:h-8 text-[#FF3A3A] hover:scale-110 transform duration-200" />
            </button>
        </div>
        <div className="p-5 overflow-y-auto">
          <div className="flex flex-col justify-center items-center gap-3 pb-4">
            <img width={60} src="/images/bookingConfirmation.png" alt="check"/>
            <p className="font-bold text-center text-xl">{t("creditPurchasedConfirmation")}</p>
          </div>
          <hr />
          <div className="flex justify-between gap-5 items-center flex-wrap py-4">
            <p className="font-bold capitalize">{t("payFor")}</p>
            <p className="font-bold capitalize">{t("creditPackage")}</p>
          </div>
          <div className="flex justify-between gap-5 items-center flex-wrap py-4">
            <p className="font-bold capitalize">{t("period")}</p>
            <p className="font-bold capitalize">
              {`${credits.period} ${credits.period === 1 ? "month" : "months"}`}
            </p>
          </div>
          <div className="flex justify-between gap-5 items-center flex-wrap py-4">
            <p className="font-bold capitalize">{t("totalPayment")}</p>
            <p className="font-bold capitalize">
              {amount || credits.price} {currency}
            </p>
          </div>
          <div className="flex justify-between gap-5 items-center flex-wrap py-4">
            <p className="font-bold capitalize">{t("PaymentComponent.credits")}</p>
            <div className="flex gap-2.5">
              <p  className="font-bold capitalize">
                {credits.credit}
              </p>
              <img src="/images/coinStack.svg" alt="coins" />
            </div>
          </div>
          <hr />
          {receiptUrl ? (
              <div className="flex justify-between items-center gap-5 flex-wrap py-4">
                  <div className="text-xl font-medium">{t("receipt")}</div>
                  <div className="text-xl font-medium">
                      <a
                          href={receiptUrl}
                          target="_blank"
                          rel="noreferrer"
                      >
                          <p className="text-black hover:scale-105 transform duration-200">
                              <FiDownload className="inline" size={25} />
                          </p>
                      </a>
                  </div>
              </div>
          ) : null}
        </div>
    </div>
  );
};

export default CreditPackageSuccess;
